export default class StickyAddToCart extends HTMLElement {

	connectedCallback() {
		this.wrapper = this.parentElement;
		if (!this.wrapper) return;

		this.productSectionHidden = false;
		this.footerVisible = false;

		const productSection = this.closest('.shopify-section.product');

		this.observer = new IntersectionObserver(
			([entry]) => {
				this.productSectionHidden = !entry.isIntersecting;
				this.toggle();
			},
			{ threshold: 0 }
		);

		this.footerObserver = new IntersectionObserver(
			([entry]) => {
				this.footerVisible = entry.isIntersecting;
				this.toggle();
			},
			{ threshold: 0 }
		);

		if (productSection) this.observer.observe(productSection);

		const footer = document.querySelector('.site-footer');
		if (footer) this.footerObserver.observe(footer);
	}

	disconnectedCallback() {
		this.observer?.disconnect();
		this.footerObserver?.disconnect();
	}

	toggle() {
		const shouldBeFixed = this.productSectionHidden && !this.footerVisible;

		const classesToAdd = [
			"fixed","top-full","left-0","w-dvw","z-beneath-header","px-[--site-gutter]","py-3", "@2xl:py-4","bg-white","shadow-sm","border-t","border-t-current", "-translate-y-full"
		]

		const animateIn = () => {
			this.wrapper.style.minHeight = this.getBoundingClientRect().height + 'px';
			classesToAdd.forEach(cls => this.classList.add(cls));
		};

		const animateOut = () => {
			this.classList.remove('-translate-y-full');
			setTimeout(() => {
				classesToAdd.forEach(cls => this.classList.remove(cls));
				this.wrapper.style.minHeight = '';
			}, 300);
		};

		if (shouldBeFixed && !this.classList.contains('fixed')) {
			animateIn();
		} else if (!shouldBeFixed) {
			animateOut();
		}
	}
}
